// components
import PopperButton, { OwnProps as IPopperButtonProps } from 'components/popper-button';
// mui components
import { IconButton } from '@mui/material';
// custom hooks
// api
import { useGetMeQuery } from 'redux-store/api/auth';
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
// icons
import DeleteIcon from 'assets/icons/buttons/delete.svg';
import EditIcon from 'assets/icons/buttons/edit.svg';
import VerticalDotsIcon from 'assets/icons/buttons/table-dots.svg';
// types
import { IPost } from '_interfaces/post.interface';
import { IPostItemProps } from '../UserPost';

interface IOptions {
  placeOfUse: IPostItemProps['placeOfUse'];
  post: IPost;
  projectId: number;
  onEdit?: () => void;
  onDelete?: (id: string) => void;
}

export const useActionsPopper = ({ post, onEdit, onDelete }: IOptions) => {
  const { data: userMe } = useGetMeQuery();
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery();

  const isMe = userMe?.id?.toString() === post.createdBy?.userId;

  const canEditPost = isMe || userPermissions?.ACTIVITY_FEED_ALL_POSTS?.canUpdate;

  const canDeletePost = isMe ||
    (userPermissions?.ACTIVITY_FEED_ALL_POSTS?.canDelete &&
      userPermissions?.ENABLE_ACTIVITY_FEED?.canDelete);

  const items: IPopperButtonProps['items'] = [
    ...(onEdit
      ? [
          {
            label: 'Edit',
            Icon: EditIcon,
            onClick: onEdit,
            hide: !canEditPost,
          },
        ]
      : []),
    ...(onDelete
      ? [
          {
            label: 'Delete',
            Icon: DeleteIcon,
            onClick: () => onDelete(post.id),
            hide: !canDeletePost,
          },
        ]
      : []),
  ];

  if (!items.length) return null;

  const popperButton =
    canEditPost || canDeletePost ? (
      <PopperButton
        width="200px"
        name="phase-item-options"
        customPlacement="bottom"
        className="dot-menu drawer"
        items={items}
        ButtonComponent={
          <IconButton
            sx={{
              width: '20px',
              height: '20px',
              padding: 0,
              '& svg': {
                width: '20px',
                height: '20px',
              },
            }}
          >
            <VerticalDotsIcon />
          </IconButton>
        }
      />
    ) : null;

  return { popperButton };
};
